import styled from '@emotion/styled';

export const AnimatedPlaceholder = styled.div`
  background: ${({ theme }) =>
    theme.dark ? theme.bgColors.secondary : '#e2e4e6'} !important;
  background-size: 850px 104px;
`;
